import type { IdkIssuerRegionMapping } from '../hooks/use-env-config/index.js';
import type { OidcUser } from '../types/oidc-user-info';
import { getSessionData } from './session-utils';
import { AUTH_OIDC_USER_INFO } from './globals';

export enum IdkRegion {
  EMEA = 'emea',
  AP = 'ap',
  NA = 'na',
}

export interface AccessToken {
  sub: string;
  iss: string;
  aud: string;
}

export function getUserId(): string {
  const sessionData = getSessionData(AUTH_OIDC_USER_INFO.sessionKey);
  if (!sessionData || typeof sessionData !== 'object') return '';

  if ('data' in sessionData) {
    const { sub: userId }: OidcUser = sessionData.data as OidcUser;
    return userId;
  }

  return '';
}
export function getLoginRegion(
  iss: string,
  issuerRegionMapping?: IdkIssuerRegionMapping,
): IdkRegion {
  if (!issuerRegionMapping) {
    throw new Error(`The issuerRegionMapping is not set`);
  }

  const regionSet = Object.entries(issuerRegionMapping).find(([_region, issuer]) => issuer === iss);

  if (regionSet && regionSet.length > 0) {
    switch (regionSet[0]) {
      case 'emea':
        return IdkRegion.EMEA;
      case 'ap':
        return IdkRegion.AP;
      case 'na':
        return IdkRegion.NA;
      default:
    }
  }

  throw new Error(`The issuer '${iss}' could not be found in the mapping`);
}
